import React, { useCallback } from 'react';
import clsx from 'clsx';

import defaultImageThumb from 'assets/images/pictures/wilko/product-fallback.png';

import style from './thumbImage.module.scss';

const ThumbImage = ({
  currImgId,
  el,
  handleSetCurrentImage,
  index,
  altTag,
}) => {
  const isActiveSlide = el.id === currImgId;

  const handleClickOnThumbImage = useCallback(() => {
    if (!isActiveSlide) {
      handleSetCurrentImage(el, index, true);
    }
  }, [el, handleSetCurrentImage, index, isActiveSlide]);

  return (
    <div
      className={clsx(style.product, isActiveSlide && style.activeSlide)}
      onClick={handleClickOnThumbImage}
      data-testid={`setCurrImg-btn ${index}`}
    >
      <picture>
        <source srcSet={el.webp?.thumb} type="image/webp" />
        <img
          className={style.thumbImage}
          src={el.thumb || el.src || defaultImageThumb}
          alt={altTag}
        />
      </picture>
    </div>
  );
};

export default ThumbImage;
